import axios from "axios";
import { ENDPOINT_AUTH_REQUEST, ENDPOINT_SESSION, ENDPOINT_LOGOUT, AUTH_SERVER, CLIENT_ID, REDIRECT_PATH } from "../../constants";
import { ApiResponse } from "../types";
import { handleApiError } from "../../utils/error_handler";

export async function authorize(code:string,com:string) : Promise<any> {
    try {
        //console.log(code, com)
        const res = await axios.post<ApiResponse>(ENDPOINT_AUTH_REQUEST, {
            code:code,
            com:com
        },{withCredentials:true});
        //console.log("Authorizing...", res.data)
        return res.data;
    } catch (error) {
        throw handleApiError(error);
    }
}

export async function loadSession() : Promise<any> {
    try {
        const res = await axios.get<ApiResponse>(ENDPOINT_SESSION, {withCredentials:true});
        //console.log("load session...", res.data)  
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data;
    } catch (error) {
        throw handleApiError(error);
    }
}

export async function logout() : Promise<string> {
    try {
        const res = await axios.post<ApiResponse<string>>(ENDPOINT_LOGOUT, {}, {withCredentials:true});
        console.log("Authorizing...", res.data)
        if (res.data.Code !== "200") {
            throw handleApiError({ response: { data: res.data } });
        }
        
        return res.data.Msg as string;
    } catch (error) {
        throw handleApiError(error);
    }
}


export const redirectToLogin = (): void => {
    const redirectUrl = window.location.origin + REDIRECT_PATH//encodeURIComponent(window.location.origin + REDIRECT_PATH);
    window.location.href = `${AUTH_SERVER}/sso?redir=${redirectUrl}&client=${CLIENT_ID}`;
};